module.exports = __webpack_public_path__ + "static/socials-fae8ac57e7235fa94bfa4eb8605937ac.png";